import React from 'react'

export const Submitted = 'Submitted'
export const Accepted = 'Accepted'
export const Approved = 'Approved'
export const Rejected = 'Rejected'
export const Routing = 'Routing'
export const Routed = 'Routed'